// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PopoverAddColumns-noColumns__vIHzW{display:flex;align-items:center;justify-content:center;height:var(--size-16)}.PopoverAddColumns-noColumnsText__BMiWw{color:var(--gray-11);font:var(--font-caption-medium-400);font-feature-settings:var(--feature-settings-caption-medium-400);letter-spacing:var(--letter-spacing-caption-medium-400)}.PopoverAddColumns-searchInput__hSLLB{padding:var(--size-1_5)}.PopoverAddColumns-items__mY3Rf{padding:var(--size-0) var(--size-1_5) var(--size-1_5) var(--size-1_5)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"noColumns": "PopoverAddColumns-noColumns__vIHzW",
	"noColumnsText": "PopoverAddColumns-noColumnsText__BMiWw",
	"searchInput": "PopoverAddColumns-searchInput__hSLLB",
	"items": "PopoverAddColumns-items__mY3Rf"
};
export default ___CSS_LOADER_EXPORT___;
